import React from 'react';
import './ProgressBar.css';

interface ProgressBarProps {
  progress: number; 
  step: number;     
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress, step }) => {
  const isVariant = localStorage.getItem("isVariant") === "true";
  return (
    <div className="progress-bar-container">
      <div className="progress-bar" style={{ width: `${progress}%` }}></div>
      <div className="progress-label" style={{ left: `${progress}%` }}>
        <div className="circle">{step}</div>
      </div>
      <div className="end-label">{isVariant ? 8 : 10}</div>
    </div>
  );
};

export default ProgressBar;
